import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { ConfirmationModal, ModalControlModalProps, Text, useFormField, CheckboxField } from '@frontend/design-system';
import { dontPromptForSmsDeleteConfirmation } from '../../utils/sms-delete-preferences';

interface DeleteSmsConfirmationModalProps {
  modalProps: ModalControlModalProps;
  onConfirm: () => void;
}

export const DeleteSmsConfirmationModal: FC<DeleteSmsConfirmationModalProps> = ({ modalProps, onConfirm }) => {
  const { t } = useTranslation('thread-body');
  const checkboxFieldProps = useFormField({ type: 'checkbox' });

  function confirmationHandler() {
    if (checkboxFieldProps.value) {
      dontPromptForSmsDeleteConfirmation();
    }
    onConfirm();
  }

  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Delete Message')}
      message={
        <>
          <Text>
            {t(
              'This action is irreversible, and will be replaced by a delete receipt. Are you sure you want to delete this message from the thread?'
            )}
          </Text>
          <CheckboxField
            {...checkboxFieldProps}
            name='dont-ask-again'
            label={t("Don't ask me again")}
            css={{ marginTop: `${theme.spacing(2)}` }}
          />
        </>
      }
      confirmLabel={t('Delete')}
      destructive
      onConfirm={confirmationHandler}
    />
  );
};
